import React from 'react';
import { IconButton } from "@mui/material";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronLeftIcon from "@mui/icons-material/ChevronRight";
import ChevronRightIcon from "@mui/icons-material/ChevronLeft";

interface ToggleButtonProps {
  isOpen: boolean;
  onClick: () => void;
  direction?: 'vertical' | 'horizontal';
  position?: {
    top?: number | string;
    bottom?: number | string;
    left?: number | string;
    right?: number | string;
    transform?: string;
  };
  showIndicator?: boolean;
  zIndex?: number;
  reverseDirection?: boolean; // Reverse the arrow direction logic
}

const ToggleButton: React.FC<ToggleButtonProps> = ({
  isOpen,
  onClick,
  direction = 'vertical',
  position = {},
  showIndicator = false,
  zIndex = 1,
  reverseDirection = false,
}) => {
  const getIcon = () => {
    if (direction === 'vertical') {
      if (reverseDirection) {
        // Reversed: closed = up arrow (expand), open = down arrow (collapse)
        return isOpen ? <ExpandMoreIcon /> : <ExpandLessIcon />;
      }
      // Normal: open = up arrow (collapse), closed = down arrow (expand)
      return isOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />;
    }
    return isOpen ? <ChevronRightIcon /> : <ChevronLeftIcon />;
  };

  return (
    <IconButton
      onClick={onClick}
      className={`side-panel-toggle ${isOpen ? 'panel-open' : ''}`}
      sx={{
        position: "absolute",
        bgcolor: "grey.700",
        color: '#fff',
        border: showIndicator ? "1.25px solid" : "none",
        borderColor: 'grey.500',
        padding: "6px",
        zIndex: zIndex,
        "& .MuiSvgIcon-root": {
          fontSize: "20px",
        },
        "&:hover": {
          backgroundColor: "action.hover",
        },
        boxShadow: 2,
        ...position,
      }}
    >
      {getIcon()}
    </IconButton>
  );
};

export default ToggleButton; 
